/**
 * Ссылки на внешние карты для построения маршрута.
 *
 * Маршрут не рисуется у нас на карте намеренно. Своя отрисовка потребовала бы
 * маршрутизатора — платного сервиса или своего сервера с картой страны, — а на
 * выходе дала бы линию без голоса, без пробок и без перестроения на ходу.
 * Карты телефона всё это умеют, и правильный ход — отдать точку им.
 *
 * Координаты собираются вручную через `toString`, а не через оформление чисел
 * по языку. В русском и немецком дробная часть отделяется запятой, и «52,52»
 * в адресе сломало бы точку назначения.
 *
 * Маршрут строится к той точке, где машина была в момент нажатия: вести к
 * движущейся цели не умеет ни одно приложение карт. Сказать об этом человеку —
 * дело интерфейса.
 */

/** Пара координат, пригодная для адреса. Null, если вести некуда. */
function pair(latitude: number | null, longitude: number | null): string | null {
  if (typeof latitude !== 'number' || typeof longitude !== 'number') return null
  if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) return null
  return `${latitude},${longitude}`
}

/** Apple Карты: родные на iPhone, Mac и iPad. */
export function appleMapsUrl(
  latitude: number | null,
  longitude: number | null,
  label: string,
): string | null {
  const point = pair(latitude, longitude)
  if (point === null) return null
  return `https://maps.apple.com/?daddr=${point}&dirflg=d&q=${encodeURIComponent(label)}`
}

/**
 * Google Карты: работают везде, включая браузер на компьютере.
 *
 * Имя машины принимается, но не используется: у ссылки на построение
 * маршрута Google нет места под подпись точки. Оставлено ради общей формы —
 * интерфейс перебирает обе карты одинаково и не должен знать, какая из них
 * что умеет.
 */
export function googleMapsUrl(
  latitude: number | null,
  longitude: number | null,
  _label: string,
): string | null {
  const point = pair(latitude, longitude)
  if (point === null) return null
  return `https://www.google.com/maps/dir/?api=1&destination=${point}&travelmode=driving`
}
